import styled from 'react-emotion'

import themeVars from 'ui_theme/site/globals/site.variables'

import KeyValue from './KeyValue'

const KeyValues = styled('div')`
  margin-top: ${themeVars.small};
`

export default KeyValues

KeyValues.KeyValue = KeyValue
